var localStorageKey = "adminOnboarding";
export var hideOnboardingWidgetKey = "hideOnboardingWidget";
var AdminOnboardingStorage = /** @class */ (function () {
    function AdminOnboardingStorage() {
    }
    AdminOnboardingStorage.prototype.__getData = function () {
        try {
            var data = JSON.parse(localStorage.getItem(localStorageKey));
            return data || {};
        }
        catch (e) {
            return {};
        }
    };
    AdminOnboardingStorage.prototype.getValue = function (key) {
        var data = this.__getData();
        return key ? data[key] : data;
    };
    AdminOnboardingStorage.prototype.setValue = function (key, value) {
        var data = this.__getData();
        data[key] = value;
        localStorage.setItem(localStorageKey, JSON.stringify(data));
    };
    return AdminOnboardingStorage;
}());
export default new AdminOnboardingStorage();
